import type { ImpactType } from '../impact';

export * from './bespoke-retirements';

export enum CertificateType {
  STANDARD = 'standard',
  BESPOKE_RETIREMENT = 'bespoke_retirement',
}

export type ProjectBreakdown = {
  projectId: number;
  name: string;
  country: string;
  slug: string;
  impactType: ImpactType;
  quantity: number;
  registryLink?: string;
};
